module.exports = __webpack_public_path__ + "static/img/largeIcon.437d031.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/largeIcon.png
// module id = da+E
// module chunks = 1